module.exports = __webpack_public_path__ + "img/hello.c1fa534b.png";